import React from "react";
import { useProducts } from "../../contexts/ProductContext";
import PriceItem from "./PriceItem";

const Purchase = () => {
  const { products } = useProducts();

  const productsv2 = [...products, products[0]];

  return (
    <div>
      <div className="box-title">
        <h1>Purchase</h1>
      </div>
      {productsv2.map((product) => (
        <PriceItem product={product} />
      ))}
    </div>
  );
};

export default Purchase;
